import { List } from 'immutable';

import WorkspaceMeetingModeHelper from 'Shared/model_helpers/WorkspaceMeetingMode.helper';

export const isAtEnd = meetingSession => {
  const state = WorkspaceMeetingModeHelper.getState(meetingSession);
  return state === 'end';
};

export const isAtNextSteps = meetingSession => {
  const state = WorkspaceMeetingModeHelper.getState(meetingSession);
  return state === 'next_steps';
};

export const isParticipantPopoverDismissed = (list, meetingSession) => {
  if (!List.isList(list)) return false;

  const meetingModeId = WorkspaceMeetingModeHelper.getId(meetingSession);
  return list.findIndex(id => id === meetingModeId) > -1;
};
